import { IconWrapper } from '../runtime';
export default IconWrapper('pen', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none",
      "stroke-width": props.strokeWidth
    }
  }, [h("g", {
    "attrs": {
      "id": "group-0",
      "stroke": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#333333',
      "fill": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#333333'
    }
  }, [h("path", {
    "attrs": {
      "d": "M8.75075 3.99977L10.1901 2.56043C10.7759 1.97465 11.7256 1.97465 12.3114 2.56043L13.6901 3.93911C14.2759 4.5249 14.2759 5.47465 13.6901 6.06043L12.2508 7.49977M8.75075 3.99977L3.00117 9.74913C2.83649 9.9138 2.71241 10.1146 2.63877 10.3355L1.41422 14.0094C1.34138 14.2279 1.53179 14.4436 1.75766 14.3984L5.80541 13.5888C6.0958 13.5308 6.36249 13.388 6.5719 13.1786L12.2508 7.49977M8.75075 3.99977L12.2508 7.49977",
      "stroke-linejoin": props.strokeLinejoin,
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  })])]);
});